import VueRouter from 'vue-router'
import Vue from 'vue'
Vue.use(VueRouter)
const home = () => import('@/view/home') // 首页
const checkCode = () => import('@/view/checkCode') //核验码查询
const findHome = () => import('@/view/findHome') //地图找房
const organPerson = () => import('@/view/organPerson') //机构人员
const buyHome = () => import('@/view/buyHome') //买房
const creditPublic = () => import('@/view/creditPublic') //信用公示
const evaluteRank = () => import('@/view/evaluteRank') //评价排行
const notice = () => import('@/view/notice') //公告
const homeDetail = () => import('@/view/buyHome/components/homeDetail')//查看详情
const noticeDetail = () => import('@/view/notice/detail')
const companyDetail = () => import('@/view/organPerson/companydetail')
const personDetail = () => import('@/view/organPerson/persondetail')
const prime = () => import('@/view/creditPublic/prime')
const practitioner = () => import('@/view/creditPublic/practitioner')
const notFound = () => import('@/view/notFound')

const routes = [{
		path: '/',
		redirect: 'home'
	},
	{
		path: '/home',
		component: home
	},
	{
		path: '/findHome',
		component: findHome
	},
	{
		path: '/organPerson',
		component: organPerson
	},
	{
		path: '/buyHome',
		component: buyHome
	},
	{
		path: '/checkCode',
		component: checkCode
	},
	{
		path: '/creditPublic',
		component: creditPublic
	},
	{
		path: '/evaluteRank',
		component: evaluteRank
	},
	{
		path: '/notice',
		component: notice
	},
	{
		path: '/homeDetail',
		component: homeDetail
	},
	{
		path: '/noticedetail',
		component: noticeDetail
	},
	{
		path: '/persondetail',
		component: personDetail
	},
	{
		path: '/companydetail',
		component: companyDetail
	},
	{
		// 使用路径参数传 id，避免 query 中 Base64 的 + 被 parseQuery 当成空格（与 /persondetail 的 query 传参不同，信用公示 id 常为 Base64）
		path: '/practitioner/:id',
		name: 'creditPractitioner',
		component: practitioner
	},
	{
		path: '/prime',
		component: prime
	},
	{
		path: '/notFound',
		component: notFound
	}
]

const router = new VueRouter({
	routes
})

export default router
